export const CONST_COLLECTION = 'collection';
export const CONST_COLLECTIONS = 'collections';
export const CONST_PAYEE = 'payee';
export const CONST_PAYEES = 'payees';
export const CONST_PICK_A_DATE = 'Pick a date';
export const CONST_AFTER_NUMBER_TIMES = 'After a number of times';
export const CONST_WHEN_I_CANCEL = 'When I Cancel';
export const CONST_ON_DATE = 'on-date';
export const CONST_ON_NUMBER = 'on-number';
export const CONST_ON_CANCEL = 'on-cancel';
